<template>
  <div class="report-filter-field">
    <p
      v-if="label"
      class="report-filter-field__label"
    >
      {{ label }}
    </p>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ReportFilterField',
  props: {
    label: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.report-filter-field {
  flex: 1 1 0;
  min-width: 0;
  max-width: none;
}

/* Narrow column (e.g. radio groups) — class falls through onto this root */
.report-filter-field.report-filter-field--narrow,
.report-filter-field.sla-filter-col--radio {
  flex: 0 1 auto;
  min-width: 7.5rem;
}

.report-filter-field__label {
  font-family: Roobert-Semi-Bold, Roobert-Regular, 'Segoe UI', Arial, sans-serif !important;
  font-weight: 800 !important;
  font-size: 16px !important;
  margin-bottom: 0.1rem !important;
  color: #181d1f;
  white-space: nowrap;
}

@media (max-width: 1200px) {
  .report-filter-field {
    flex: 1 1 140px;
    max-width: 220px;
  }

  .report-filter-field.report-filter-field--narrow,
  .report-filter-field.sla-filter-col--radio {
    max-width: none;
  }
}
</style>
